<template>
  <v-flex
    layout
    row
    align-center
    :class="[
      gameType === 'textInput' ? 'textClass' : null,
      gameType === 'anagram' ? 'anagramClass' : null,
    ]"
  >
    <v-text-field
      class="answerField"
      v-if="gameType === 'anagram'"
      v-model="answerText[langEdition]"
      outline
      single-line
      @blur="updateAnswerText"
      :counter="maxTextLength"
      :hint="langEdition !== locale ? answerText[locale] : null"
      :persistent-hint="showHint"
    >
      <language-translator
        v-if="locale !== langEdition"
        :langEdition="langEdition"
        :textToTranslate="answerText[locale]"
        :type="'answerText'"
        @text-translated="updateTranslatedText"
        slot="append"
      >
      </language-translator>
    </v-text-field>

    <!-- <image-input
    v-if="gameType == 'textRebus'"
    :label="$t('gameFormCard.image')"
    :default="answerImage"
    :key="answerId"
    :quizzImage="false"
    @change-image-input="updateAnswerImage"
    @error="onImageError"
    ></image-input> -->
  </v-flex>
</template>

<script>
// import ImageInput from './ImageInput';
import LanguageTranslator from '../components/LanguageTranslator.vue';

export default {
  name: 'GameText',
  components: {
    // ImageInput,
    LanguageTranslator,
  },
  props: {
    gameType: {
      type: String,
      default: null,
    },
    answer: {
      type: Object,
      default: null,
    },
    langEdition: {
      type: String,
      default: null,
    },
    showHint: {
      type: Boolean,
      default: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    maxTextLength: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      answerImage: '',
      answerText: '',
      search: '',
    };
  },
  created() {
    if (this.gameType === 'textInput') {
      this.answerText = { fr: [], en: [] };
      this.answerText.fr = this.answer.fr;
      this.answerText.en = this.answer.en;
    } else {
      this.answerText = { fr: '', en: '' };
      this.answerText.en = this.answer.en;
      this.answerText.fr = this.answer.fr;
    }
  },
  watch: {
    answer(newValue) {
      if (this.gameType === 'mcqImage') {
        // a refaire
        if (newValue && newValue.picture) {
          this.answerImage = newValue.picture.url;
        }
      } else {
        this.answerText = newValue.phrase;
      }
    },
    gameType(newValue) {
      return newValue;
    },
  },
  methods: {
    updateTags() {
      this.$nextTick(() => {
        this.answerText[this.langEdition].push(...this.search.split(','));
        this.$nextTick(() => {
          this.search = '';
        });
      });
    },
    updateAnswerText() {
      this.$emit('update-answer-text', this.answerText[this.langEdition]);
    },
    onImageError(error) {
      console.log('imageError', error.message);
    },
    updateAnswerImage(newImage) {
      this.answerImage = newImage;
      this.$emit('update-answer-image', this.answerImage, this.answerId);
    },
    updateAnswerCorrect() {
      this.$emit(
        'update-answer-value',
        this.isCorrect,
        this.answerId,
        this.gameType
      );
    },
    async updateTranslatedText(textTranslated, type) {
      if (textTranslated) {
        if (type === 'answerText') {
          this.answerText[this.langEdition] = textTranslated;
          this.updateAnswerText();
        }
      }
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="sass" scoped>

div.v-input
 width: 300px

.deleteIcon
  max-width: 20px;
  margin-left: 7px;
  margin-right: 10px;

.onlyCheckBox
  max-width: 20px
  margin-left: 5px
  margin-right: 10px
  margin-top: 0px

.checkBoxWithDelete
  max-width: 20px
  max-height: 24px
  margin-left: 5px
  margin-right: 10px
  margin-top: 0px

.surveyClass
  margin-right: 30px
  max-height: 66px
  justify: left

.surveyClassWithDelete
  margin-left: 35px
  max-height: 66px

.closeSurvey
  position: absolute

.mcqClass
  margin-top: 0px
  max-height: 66px

.imageClass
  margin-top: 0px
  max-height: 150px

.readOnlyClass
  pointer-events: none;

.showHintClass
  margin-bottom: 20px;
</style>
